<div class="card-body p-0 chapter-mom-nfr">
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-9">
                    <h5 class="mb-3">Minutes of Meeting</h5>
                </div>
                <div class="col-3 text-right">
                    <button type="button" class="btn btn-primary"
                            data-toggle="modal"
                            data-target="#modal-add-mom"
                            *ngIf="allChapters || (userRole?.MOM?.includes('CREATE') && userChapter === chapterId)">
                        <i class="uil uil-plus-circle size-20"></i> Add MOM
                    </button>
                </div>
            </div>

            <div class="col-12 py-3">
                <div class="section divider one-dashed"></div>
            </div>

            <div class="col-xl-12">
                <div class="row">
                  <div class="col-12 table-responsive rana-table-flat">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table rana-table">
                        <thead>
                        <tr>
                            <th>Date and Time</th>
                            <th>Created By</th>
                            <th>Title</th>
                        </tr>
                        </thead>
                        <tbody></tbody>
                    </table>
                  </div>
                </div>
            </div>
    </div>
</div>

<div class="modal fade modal-small" id="modal-add-mom" tabindex="-1" #addMomModal>
    <div class="modal-dialog" role="document">
        <div class="modal-content section-background-13">
            <div class="modal-body z-bigger">
                <button type="button" class="close" data-dismiss="modal">
                    <i class="uil uil-multiply"></i>
                </button>
                <div class="row justify-content-center">
                    <div class="col-12 text-center mb-3">
                        <h5>Add Minutes of Meeting</h5>
                    </div>
                    <div class="col-12">
                        <form (ngSubmit)="addMom()" #momForm="ngForm" class="nfr-form-standard">
                            <div class="form-group mt-4">
                                <input type="text" [(ngModel)]="newMom.title" name="title"
                                       class="form-style big form-style-with-icon section-shadow-blue"
                                       placeholder="Meeting Title" required/>
                                <i class="input-icon big uil uil-book-alt"></i>
                            </div>

                            <div class="form-group mt-4 form-check">
                                <input type="checkbox" id="checkbox-1" [(ngModel)]="newMom.visible" name="visible"/>
                                <label class="checkbox mb-0 size-15" for="checkbox-1">Visible to all</label>
                            </div>
                            <div class="form-group mt-4">
                                <app-rt-editor [(ngModel)]="newMom.description" name="description"
                                               placeholder="Minutes of Meeting"></app-rt-editor>
                            </div>
                            <div class="col-12 text-center mt-5">
                                <button type="submit" class="btn btn-primary" [disabled]="momForm.invalid">
                                    Submit <i class="uil uil-check-circle size-22 ml-3"></i>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modal-view-mom" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content rana-mom-modal" *ngIf="selectedMom">

            <button type="button" class="close rana-mom-close" data-dismiss="modal">
                <i class="uil uil-multiply"></i>
            </button>

            <div class="rana-mom-header">
                <div class="rana-avatar rana-mom-avatar">{{ momInitials(selectedMom.createdByName) }}</div>
                <div class="rana-mom-header-text">
                    <h6 class="rana-mom-title">{{ selectedMom.title }}</h6>
                    <div class="rana-mom-meta">
                        <span>{{ selectedMom.createdByName }}</span>
                        <span class="rana-mom-meta-dot">&middot;</span>
                        <span>{{ selectedMom.createdDate | date: 'mediumDate' }}</span>
                        <span class="rana-badge" [ngClass]="selectedMom.visible ? 'rana-badge-success' : 'rana-badge-neutral'">
                            <i class="uil uil-eye" style="margin-right:4px;"></i>{{ selectedMom.visible ? 'Visible to all' : 'Restricted' }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="rana-mom-divider"></div>

            <div class="rana-mom-content">
                <app-rt-editor [disabled]="true"
                               [ngModel]="selectedMom.description"></app-rt-editor>
            </div>

            <div class="rana-mom-actions"
                 *ngIf="(allChapters || (userRole?.MOM?.includes('UPDATE') && userChapter === chapterId))
                        || (allChapters || (userRole?.MOM?.includes('DELETE') && userChapter === chapterId))">
                <button class="rana-action-btn"
                        *ngIf="allChapters || (userRole?.MOM?.includes('UPDATE') && userChapter === chapterId)"
                        data-toggle="modal"
                        data-target="#modal-edit-mom"
                        (click)="openEditModal(selectedMom)">
                    <i class="uil uil-edit"></i> Edit
                </button>
                <button class="rana-action-btn rana-action-btn-danger"
                        *ngIf="allChapters || (userRole?.MOM?.includes('DELETE') && userChapter === chapterId)"
                        (click)="deleteMOM(selectedMom.id)">
                    <i class="uil uil-trash"></i> Delete
                </button>
            </div>

        </div>
    </div>
</div>


<div class="modal fade modal-small" id="modal-edit-mom" tabindex="-1" #editMomModal>
    <div class="modal-dialog" role="document">
        <div class="modal-content section-background-13">
            <div class="modal-body z-bigger">
                <button type="button" class="close" data-dismiss="modal">
                    <i class="uil uil-multiply"></i>
                </button>
                <div class="row justify-content-center">
                    <div class="col-12 text-center mb-3">
                        <h5>Edit MOM</h5>
                    </div>
                    <div class="col-12" *ngIf="selectedMom as editingMom">
                        <form (ngSubmit)="updateMOM(editingMom.id, editingMom)" #editForm="ngForm" class="nfr-form-standard">
                            <div class="form-group mt-4">
                                <input type="text" [(ngModel)]="editingMom.title" name="editTitle"
                                       class="form-style big form-style-with-icon section-shadow-blue" required/>
                                <i class="input-icon big uil uil-book-alt"></i>
                            </div>

                            <div class="form-group mt-4 form-check">
                                <input type="checkbox" id="checkbox-edit-visible" [(ngModel)]="editingMom.visible"
                                       name="editVisible"/>
                                <label for="checkbox-edit-visible" class="checkbox mb-0 size-15">Visible to all</label>
                            </div>
                            <div class="form-group mt-4">
                                <app-rt-editor [(ngModel)]="editingMom.description" name="editDescription"></app-rt-editor>
                            </div>
                            <div class="col-12 text-center mt-5">
                                <button type="submit" class="btn btn-success" [disabled]="editForm.invalid">
                                    Save Changes <i class="uil uil-check-circle size-22 ml-3"></i>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
